function calculateDurationInMinutes(start_time: string, end_time: string): string {
  const startTimeParts = start_time.split(':').map(Number);
  const endTimeParts = end_time.split(':').map(Number);

  const startMinutes = startTimeParts[0] * 60 + startTimeParts[1];
  const endMinutes = endTimeParts[0] * 60 + endTimeParts[1];

  const duration = endMinutes - startMinutes;

  if (duration >= 60) {
    const hours = Math.floor(duration / 60);
    const minutes = duration % 60;
    return `${hours}h ${minutes} mins`;
  }

  return `${duration} mins`;
}

export default calculateDurationInMinutes;
